import classNames from 'classnames';
import { STORIES_PAGE_SIZE } from '../contants';
interface Props {
  count?: number;
  className?: string;
}
export default function Skeleton({
  count = STORIES_PAGE_SIZE,
  className
}: Props) {
  return <div className={classNames('hidden-scrollbr flex w-full gap-3 overflow-auto whitespace-nowrap bg-white lg:hidden', className)} data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            {Array(count).fill({}).map((_, index) => <div key={index} className='h-16 w-16 shrink-0 animate-pulse rounded-full bg-gray-100' />)}
        </div>;
}